/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBill } from './APIBill';
import {
    APIBillFromJSON,
    APIBillFromJSONTyped,
    APIBillToJSON,
} from './APIBill';

/**
 * 
 * @export
 * @interface APIPaginatedBillList
 */
export interface APIPaginatedBillList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedBillList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBillList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBillList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIBill>}
     * @memberof APIPaginatedBillList
     */
    results: Array<APIBill>;
}

/**
 * Check if a given object implements the APIPaginatedBillList interface.
 */
export function instanceOfAPIPaginatedBillList(value: object): value is APIPaginatedBillList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedBillListFromJSON(json: any): APIPaginatedBillList {
    return APIPaginatedBillListFromJSONTyped(json, false);
}

export function APIPaginatedBillListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedBillList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIBillFromJSON)),
    };
}

export function APIPaginatedBillListToJSON(value?: APIPaginatedBillList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIBillToJSON)),
    };
}

